"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractSourceResponseToJSON = exports.ContractSourceResponseFromJSONTyped = exports.ContractSourceResponseFromJSON = void 0;
function ContractSourceResponseFromJSON(json) {
    return ContractSourceResponseFromJSONTyped(json, false);
}
exports.ContractSourceResponseFromJSON = ContractSourceResponseFromJSON;
function ContractSourceResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'source': json['source'],
        'publish_height': json['publish_height'],
        'proof': json['proof'],
    };
}
exports.ContractSourceResponseFromJSONTyped = ContractSourceResponseFromJSONTyped;
function ContractSourceResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'source': value.source,
        'publish_height': value.publish_height,
        'proof': value.proof,
    };
}
exports.ContractSourceResponseToJSON = ContractSourceResponseToJSON;
//# sourceMappingURL=ContractSourceResponse.js.map